module.exports = __webpack_public_path__ + "static/media/Montgomery Hall.047fe266.mp3";